/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import Vue from 'vue';
import store from '@/store';
import { versionCompare } from '@/shared/utils/versionCompare';
import GetDeviceFingerprintHash from '@/shared/utils/risk';
import platform from '@/shared/utils/platform';

// 判断活体识别是否需要上传设备指纹信息，用于在底层风控环节控制应该启用的人脸sdk类型
export const getDeviceRiskData = async (): Promise<{
  'fingerprint-hash': string;
} | undefined> => {
  /** 哈啰 app 内返回指纹，鸿蒙暂时不支持，先过滤 */
  if (platform.isHelloApp && versionCompare(store.state.base.deviceInfo.appVersion || '5.82.0', '5.33.0') >= 0 && !platform.isHarmony) {
    return {
      'fingerprint-hash': await GetDeviceFingerprintHash.getDeviceFingerprintHash(),
    };
  }
  return undefined;
};

// TODO:摄像头唤起前置校验
// 检查是否⽀持webRTC，前提条件：当前是https协议的⽹⻚才能正确检测
export const checkWebRTC = async (): Promise<boolean> => {
  // 非https 的 返回true，避免本地开发受影响
  if (!/^https:\/\//.test(window.location.href)) {
    return true;
  }

  // https 才能正常获取navigator.mediaDevices，不然就是 undefined
  if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
    try {
      const hasMediaAuth = await navigator.mediaDevices.getUserMedia(
        { video: { facingMode: 'user' } },
      );
      if (hasMediaAuth) {
        // eslint-disable-next-line no-console
        console.error('支持摄像头');
        // 唤起后，关闭摄像头设备
        hasMediaAuth.getVideoTracks()[0].stop();
        return true;
      }

      // eslint-disable-next-line no-console
      console.error('不支持摄像头');
      return false;
      /* use the stream */
    } catch (err) {
      /* handle the error */
      // eslint-disable-next-line no-console
      console.error('唤起异常 不支持摄像头 ', err);
      return false;
    }
  }
  // eslint-disable-next-line no-console
  console.error('没获取到摄像头信息，不支持摄像头');
  return false;
};


// 记录活体各种操作或者操作结果埋点 getCheckFacePage
export const saveLivenessActionUBT = (
  vueInstance: Vue,
  content: string,
  productId?: string | number,
): void => {
  const pageId = String(
    (
      vueInstance.$route
      && vueInstance.$route.meta
      && vueInstance.$route.meta.pageId
    ) || '',
  );

  vueInstance.$ubtPageButton(
    `臻有钱_${content}`,
    'productId',
    String(productId),
  );

  // 臻有钱_提现申请页 => 提现申请页
  const pageName = String(pageId).replace('臻有钱_', '');

  vueInstance.$ubtPageButton(
    `臻有钱_${content}_${pageName}`,
    'productId',
    String(productId),
  );
};
